import { useContext } from "react";
import {
  FirmaFiltersContext,
  FirmaFiltersEventContext,
} from "../../../../../context/FiltersContext";
import {
  FirmaStatusFilterSetting,
  QueryFilter,
  FirmaFilterKeys,
} from "../../../../../interfaces/filters";
import { FirmaDtoFilterInput } from "../../../../../interfaces/schema";
import { f } from "../../../../../util/f";
import { AccordionFilterItem } from "../../../../accordion/Accordion";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../../../select/Select";

// helper
const filterKey: QueryFilter<FirmaFilterKeys>["filterKey"] = "status";

export default function FirmaStatusFilter() {
  // query filter context
  const filters = useContext(FirmaFiltersContext);
  const updateFilters = useContext(FirmaFiltersEventContext);

  // find the filter settings
  const settings: FirmaStatusFilterSetting = filters.find(
    (f) => f.filterKey === filterKey,
  )?.settings;
  // handler
  function selectEventHandler(value: FirmaStatusFilterSetting["selected"]) {
    if (value === null) {
      updateFilters({
        event: "delete",
        queryFilter: {
          filterKey: filterKey,
        },
      });
      return;
    }

    const queryFilter: QueryFilter<FirmaFilterKeys, FirmaStatusFilterSetting> =
      {
        filterKey: filterKey,
        filter: f<FirmaDtoFilterInput>()
          .addFilter("aktiv", {
            eq: value,
          })
          .build(),
        parentFilter: "and",
        settings: {
          selected: value,
        },
      };

    updateFilters({
      event: "update",
      queryFilter: queryFilter,
    });
  }
  return (
    <AccordionFilterItem
      title="Status"
      value="virksomhedsstatus"
      isActive={settings ? (settings?.selected === null ? false : true) : false}
    >
      <Select
        defaultValue={settings ? String(settings?.selected) : "null"}
        value={settings ? String(settings?.selected) : "null"}
        onValueChange={(value: string) => {
          selectEventHandler(JSON.parse(value));
        }}
      >
        <SelectTrigger
          aria-label="Vælg filterfunktion"
          className={`${
            settings
              ? settings?.selected === null
                ? false
                : "filter-is-active"
              : ""
          }`}
        />
        <SelectContent small>
          <SelectItem value={"null"} key={"null"}>
            Alle
          </SelectItem>
          <SelectItem value={"true"} key={"true"}>
            Aktiv
          </SelectItem>
          <SelectItem value={"false"} key={"false"}>
            Inaktiv
          </SelectItem>
        </SelectContent>
      </Select>
    </AccordionFilterItem>
  );
}
